import { ProjectProvider, useProjectContext } from '@/context/ProjectContext';
import { AgentConfigProvider } from '@/context/AgentConfigContext';
import { TableGraphProvider } from '@/context/TableGraphContext';
import { NotesProvider } from '@/context/NotesContext';
import { FragmentsProvider } from '@/context/FragmentsContext';
import { TodoProvider } from '@/context/TodoContext';
import { WorkflowsProvider } from '@/context/WorkflowsContext';
import { WorkflowFilesProvider } from '@/context/WorkflowFilesContext';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ThreadSidebarProvider } from '@/context/ThreadSidebarContext';
import { SystemConfigProvider } from '@/context/SystemConfigContext';
import { LLMConfigProvider } from '@/context/LLMConfigContext';
import { UserManagementProvider } from '@/context/UserManagementContext';
interface ReviewUIProvidersProps {
  children: React.ReactNode;
}

/**
 * Hands the file collection the project it is holding files for, so an upload
 * that arrives without one is still recorded as this project's. Read here
 * rather than inside the provider because the provider is also mounted on its
 * own, without a project around it.
 */
const ProjectScopedWorkflowFiles = ({ children }: ReviewUIProvidersProps) => {
  const { selectedProjectId } = useProjectContext();
  return (
    <WorkflowFilesProvider projectId={selectedProjectId}>
      {children}
    </WorkflowFilesProvider>
  );
};

const ReviewUIProviders = ({ children }: ReviewUIProvidersProps) => {
  return (
    <SystemConfigProvider>
      <LLMConfigProvider>
        <UserManagementProvider>
          <ProjectProvider>
            <AgentConfigProvider>
              <TableGraphProvider>
                <NotesProvider>
                  <FragmentsProvider>
                    <TodoProvider>
                      <ThreadSidebarProvider>
                        <WorkflowsProvider>
                          <ProjectScopedWorkflowFiles>
                            <DndProvider backend={HTML5Backend}>
                              {children}
                            </DndProvider>
                          </ProjectScopedWorkflowFiles>
                        </WorkflowsProvider>
                      </ThreadSidebarProvider>
                    </TodoProvider>
                  </FragmentsProvider>
                </NotesProvider>
              </TableGraphProvider>
            </AgentConfigProvider>
          </ProjectProvider>
        </UserManagementProvider>
      </LLMConfigProvider>
    </SystemConfigProvider>
  );
};

export default ReviewUIProviders;
